import { GiEagleEmblem } from "react-icons/gi"
import { MdMilitaryTech } from "react-icons/md"
import { BsTwitter } from "react-icons/bs"
import { FaDiscord } from "react-icons/fa"
import { IconContext } from "react-icons";
import { IoStorefrontSharp } from "react-icons/io5"
import { GiHamburgerMenu } from "react-icons/gi"
import { GiEagleHead } from "react-icons/gi"
import s from "./navbar.module.css"
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { FaUser } from "react-icons/fa"
import { ImUser } from "react-icons/im"
import SimpleDialog from "../../Login/dialogLogin/DialogLogin"

export default function Navbar({ colorFondo }) {
    const [style, setStyle] = useState("")
    const [openLogin, setOpenLogin] = useState(false)
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpenLogin(false);
    };
    const navigate = useNavigate()

    let navStyle = colorFondo + style
    useEffect(() => {
        window.addEventListener("scroll", () => {
            let activeClass = colorFondo;
            // console.log(window.screenY)
            if (window.scrollY > 0) {
                activeClass = colorFondo + "Move";
                setStyle("Move")
            } else setStyle("")
        })
    }, [])
    return (
        <nav className={s[navStyle]}>
            <IconContext.Provider value={{ className: s.icon, size: "2.5em" }}>

                <div className={s.container}>
                    {/* <div><GiEagleEmblem/></div> */}
                    <div onClick={() => navigate("/")}><GiEagleHead /></div>
                    <div className={s.hamb}>
                        <GiHamburgerMenu />
                    </div>
                    <div className={s.redes}>
                        <div className={s.iconContainer} data-tool="Twitter"><BsTwitter onClick={() => window.open("https://twitter.com/Venom_Soldiers")} /><div data-tool-tip="Twitter" className={s.twitter}></div></div>
                        {/* <div className={s.iconContainer} data-tool="Discord"><FaDiscord onClick={()=>window.open("https://discord.com/invite/JubnQbGN4W")}/><div data-tool-tip="Discord" className={s.discord}></div></div> */}
                        <div className={s.iconContainer} data-tool="Discord"><FaDiscord onClick={() => window.open("https://discord.gg/bRAEzzgWRE")} /><div data-tool-tip="Discord" className={s.discord}></div></div>
                        {/* <div className={s.iconContainer} data-tool="Discord"><FaDiscord onClick={()=>setOpen(!open)}/><div data-tool-tip="Discord" className={s.discord}></div></div> */}
                        <div className={s.iconContainer} data-tool="Projects"><MdMilitaryTech onClick={() => navigate("/projects")} /><div data-tool-tip="Projects" className={s.marketplace}></div></div>
                        <div className={s.iconContainer} data-tool="Projects"><ImUser onClick={()=>setOpenLogin(true)} /><div data-tool-tip="Log in" className={s.marketplace}></div></div>
                    </div>
                </div>
                <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={open} autoHideDuration={3000} onClose={() => setOpen(false)}>
                    <Alert onClose={() => setOpen(false)} severity="info" sx={{ width: '100%' }}>
                        Coming soon!
                    </Alert>
                </Snackbar>
                <SimpleDialog onClose= {handleClose} open={openLogin} />
            </IconContext.Provider>
        </nav>
    )
}